import { QueryFunctionContext } from 'react-query';
import { baseQuery } from '../baseQuery';
import { PrepaidProductStatus } from 'types';

type CustomerId = number;

export const getCustomerProducts = async ({
  queryKey,
}: QueryFunctionContext<[string, CustomerId, PrepaidProductStatus | '']>) => {
  const { data } = await baseQuery(`customer-products?customer_id=${queryKey[1]}&status=${queryKey[2]}`);

  return data;
};
